import { render, staticRenderFns } from "./PopupShipmentForm.vue?vue&type=template&id=a276c16c&"
import script from "./PopupShipmentForm.vue?vue&type=script&lang=js&"
export * from "./PopupShipmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports